<template>
	<div
		class="site_button"
		:class="[theme, type]"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>
		<span v-html="type === 'close' ? 'Close' : 'Menu'"></span>

		<div class='icon'>

			<svg
				v-if="type === 'close'"
				xmlns="http://www.w3.org/2000/svg"
				width="18.031"
				height="18.374"
				viewBox="0 0 18.031 18.374"
			>
				<g
					id="Exit"
					transform="translate(-267.487 -1366.303)"
				>
					<line
						id="Line_2"
						data-name="Line 2"
						x2="24"
						transform="translate(268.018 1383.803) rotate(-45)"
						fill="none"
						stroke="#2c584e"
						stroke-width="1.5"
					/>
					<line
						id="Line_1"
						data-name="Line 1"
						x2="24"
						transform="translate(268.018 1367.176) rotate(45)"
						fill="none"
						stroke="#2c584e"
						stroke-width="1.5"
					/>
				</g>
			</svg>

			<svg
				v-if="type === 'open'"
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="13.5"
				viewBox="0 0 24 13.5"
			>
				<g
					id="Hamburger"
					transform="translate(0 0.75)"
				>
					<line
						id="Line_2"
						data-name="Line 2"
						x2="24"
						transform="translate(0 12)"
						fill="none"
						stroke="#2c584e"
						stroke-width="1.5"
					/>
					<line
						id="Line_1"
						data-name="Line 1"
						x2="24"
						fill="none"
						stroke="#2c584e"
						stroke-width="1.5"
					/>
				</g>
			</svg>

		</div>

	</div>
</template>

<script>
import Close from '../../images/close_X.svg';
import Open from '../../images/menu.svg';

export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
			open: Open,
			close: Close,
		};
	},

	props: {
		label: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	flex-direction: row;
	transition: 0.2s ease all;
	text-decoration: none;
	justify-content: center;
	align-items: center;
	position: relative;
	border-radius: 0;
	background: transparent;
	align-items: center;
	gap: 6px;
	width: 40px;
	height: 40px;

	.scrolled & {
		background: white;
		/* padding: 12px 24px 10px; */

		span {
			color: var(--gum-green);
		}

		svg {
			display: flex;
			/* max-width: 24px;
			max-height: 12px; */
			/* margin-left: 8px; */

			&::v-deep {
				line {
					stroke: var(--gum-green);
				}
			}
		}
	}

	@media (hover) {
		&:hover {
			transition: 0.2s ease all;
			cursor: pointer;

			span {
				transition: 0.2s ease all;
			}
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal normal 15px/20px var(--primary-font-family);
		text-transform: uppercase;
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
		color: var(--gum-green);
	}

	.icon {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 23px;
	}

	svg {
		display: flex;
		/* max-width: 24px;
		max-height: 12px;
		margin-left: 8px; */

		&::v-deep {
			line {
				stroke: var(--gum-green);
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MenuButton.vue